import React from 'react';
import loadable from '@loadable/component';

const FootnotesContainer = loadable(() => import('./footnotes-container'));

const FootnotesDisclaimer = ({ pdpFootnotesDisclaimer, title, accordionProps }) => {
    if (!pdpFootnotesDisclaimer) return null;

    return (
        <FootnotesContainer
            pdpFootnotesDisclaimer={pdpFootnotesDisclaimer}
            title={title}
            accordionProps={accordionProps}
        />
    );
};

export default FootnotesDisclaimer;
